import IncodeFaceAuth from "./components/IncodeLivenessComponent";

interface IncodeLivenessProps {
    livenessSessionId: string;
    sessionId: string;
    sessionToken: string;
    interviewId: string;
    apiUrl: string;
    onConnectionError?: () => void;
}

export default function IncodeLiveness({ livenessSessionId, sessionId, sessionToken, interviewId, apiUrl, onConnectionError }: IncodeLivenessProps) {
    return (
        <IncodeFaceAuth
            apiUrl={apiUrl}
            identityId={sessionId}
            sessionToken={sessionToken}
            interviewId={interviewId}
            livenessSessionId={livenessSessionId}
            onConnectionError={onConnectionError}
        />
    )
}
